import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { IQuickLinksSharepoint } from "../../InterfacesTypes/interfaces";

export const DISPATCHES = {
  SAGA_GET_QUICKLINKS_DATA: "quickLinks/SAGA_GET_QUICKLINKS_DATA",
  QUICKLINKS_LOADING: "quickLinks/QUICKLINKS_LOADING",
  QUICKLINKS_SUCCESS: "quickLinks/QUICKLINKS_SUCCESS",
  QUICKLINKS_ERROR: "quickLinks/QUICKLINKS_ERROR",

  // SAGA_GET_QUICKLINKS_DATA: "svgQuickLinks/SAGA_GET_QUICKLINKS_DATA",
  // QUICKLINKS_LOADING: "svgQuickLinks/QUICKLINKS_LOADING",
  // QUICKLINKS_SUCCESS: "svgQuickLinks/QUICKLINKS_SUCCESS",
  // QUICKLINKS_ERROR: "svgQuickLinks/QUICKLINKS_ERROR",
} as const;

export interface QuickLinksState {
  quickLinksItems: IQuickLinksSharepoint[];
  loading: boolean;
  error: string | null;
}

const initialState: QuickLinksState = {
  quickLinksItems: [],
  loading: false,
  error: null,
};

export const fetchQuickLinks = createAction("quickLinks/fetchQuickLinks");

export const quickLinksSlice = createSlice({
  // name: "svgQuickLinks",
  name: "quickLinks",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<IQuickLinksSharepoint[]>) {
      state.loading = false;
      state.quickLinksItems = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },
    // optional local setter
    setQuickLinks(state, action: PayloadAction<IQuickLinksSharepoint[]>) {
      state.quickLinksItems = action.payload;
    },
  },
});

export const { fetchStart, fetchSuccess, fetchFailure, setQuickLinks } =
  quickLinksSlice.actions;

export const quickLinksReducer = quickLinksSlice.reducer;
